import * as React from "react";
import type { SVGProps } from "react";
const SvgBed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={27}
    height={15}
    fill="none"
    {...props}
  >
    <path
      fill="#050033"
      d="M25.447 12.636 24.4 10.294a4.09 4.09 0 0 0-3.736-2.423H5.554c-1.611 0-3.078.95-3.735 2.423L.772 12.636h5.302v1.339h2.313v-1.34h9.445v1.34h2.313v-1.34zM5.274 7.362a1 1 0 0 1-.016-.197V5.903c0-.764.622-1.386 1.386-1.386h4.775c.764 0 1.386.622 1.386 1.386v1.262q0 .095-.013.187h.653a1.4 1.4 0 0 1-.013-.187V5.903c0-.764.622-1.386 1.386-1.386h4.775c.764 0 1.386.622 1.386 1.386v1.262q0 .103-.016.197c.373.024.738.092 1.084.202.223-.304.357-.68.357-1.086V2.866c0-1.021-.83-1.851-1.85-1.851H5.67c-1.019 0-1.85.83-1.85 1.85v3.613c0 .407.133.782.356 1.086a4.6 4.6 0 0 1 1.098-.202"
    />
    <path
      fill="#050033"
      d="M12.251 7.352a1 1 0 0 0 .021-.187V5.903a.856.856 0 0 0-.855-.856H6.644a.856.856 0 0 0-.855.856v1.262q0 .095.02.187zM20.423 7.352a1 1 0 0 0 .02-.187V5.903a.856.856 0 0 0-.855-.856h-4.772a.856.856 0 0 0-.856.856v1.262q0 .095.021.187z"
    />
  </svg>
);
export default SvgBed;
